<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const globalConfig = useMapGetter('globalConfig/get');

const gitSha = computed(() => {
  return globalConfig.value.gitSha ? globalConfig.value.gitSha.substring(0, 7) : '2026.08.26';
});

const copyGitSha = () => {
  copyTextToClipboard(globalConfig.value.gitSha || 'ZetDesk 4.16.2 Enterprise');
};
</script>

<template>
  <div class="p-4 text-sm text-center">
    <div class="divide-x divide-n-slate-9 flex items-center justify-center gap-2">
      <span class="px-2 font-semibold text-woot-500">ZetDesk v4.16.2</span>
      <span
        v-tooltip="'Copiar identificador da Build'"
        class="px-2 build-id cursor-pointer text-xs text-n-slate-11 hover:text-n-slate-12"
        @click="copyGitSha"
      >
        Build 2026.08.26
      </span>
    </div>
  </div>
</template>
